import { applyMiddleware, combineReducers, createStore } from "redux"
import {todoReducer} from './todo/storetwo.js'
import { userReducer } from "./redux-thunk/store3.js"
import { thunk } from "redux-thunk"
const initialState={
    balance:0,
    fullName:"",
    mobile : null,
}

function accountreducer(state=initialState,action){

switch(action.type){
    case "deposit":
  return {...state,balance:state.balance+ +action.payload}
    case "withdraw":
    return {...state,balance:state.balance- +action.payload}
    case "mobileupdate":
    return {...state,mobile:action.payload}
    case "nameupdate":
    return {...state,fullName:action.payload}
    case "reset":
      return initialState
    default:
        return state;
}

// if(action.type==="deposit"){
//   return {...state,balance:state.balance+action.payload}
// }else if(action.type==="withdraw"){
//     return {...state,balance:state.balance-action.payload}
// }else if(action.type==="mobileupdate"){
//     return {...state,mobile:action.payload}
// }else if(action.type==="nameupdate"){
//     return {...state,fullName:action.payload}
// }else{
//     return state
// }
}

let transactionReducer=(state=[],action)=>{
  switch(action.type){
    case  "addTransaction":
      return [...state,
        {
          id:action.payload.id,
          amount:action.payload.amount,
          type:action.payload.type,
          date:action.payload.date,
          
        }
      ]
      default:
        return state
  }
}

let rootReducer=combineReducers(
  {
    account:accountreducer,
    transaction:transactionReducer,
    storetwo:todoReducer,
    store3:userReducer
  }
)


let store=createStore(rootReducer,applyMiddleware(thunk))
// console.log(store.getState());
// store.dispatch({type:"account/deposit",payload:1000})
// console.log(store.getState());
// store.dispatch({type:"withdraw",payload:500})
// store.dispatch({type:"mobileupdate",payload:8008432612})
// store.dispatch({type:"nameupdate",payload:"satya"})
// console.log(store.getState());
 

export default store



























// let obj1={
//     name:"satya"
// }
//let obj2={...obj1} //creating new object